var paper = require('./paper');

var DollarOne = require('./redollar/DollarOne');
var dollarOne = new DollarOne({ threshold: 0.4});


// Add default gesture matches to dollarOne.
var matchShapes = {
  "counter-circle": [[313,707],[305,695],[291,676],[275,624],[266,600],[265,584],[260,540],[258,487],[313,379],[371,346],[407,328],[441,319],[492,318],[544,316],[577,326],[631,344],[676,389],[744,481],[741,534],[709,636],[695,661],[638,712],[601,734],[571,736],[552,741]],
  "zig-zag": {
    0: [[286,241],[441,278],[646,363],[723,403],[742,419],[743,420],[737,420],[731,419],[710,417],[657,423],[559,470],[467,502],[386,518],[372,521],[371,527],[396,530],[507,554],[629,595],[683,619],[713,638],[771,671]],
    1: [[283,224],[305,235],[370,263],[425,284],[517,313],[609,348],[690,373],[713,383],[719,386],[713,387],[691,391],[619,421],[564,454],[422,507],[383,519],[348,533],[354,535],[368,536],[399,547],[451,567],[499,582],[596,616],[646,629],[699,648],[764,674],[786,684]],
    2: [[284,231],[324,241],[447,290],[557,317],[575,326],[612,343],[645,355],[683,370],[706,377],[697,380],[685,383],[630,397],[556,426],[432,478],[381,494],[355,497],[331,509],[373,535],[413,557],[536,605],[662,670],[746,715],[776,729]],
    3: [[364,251],[493,300],[618,340],[655,351],[668,357],[672,360],[663,365],[615,397],[448,449],[346,492],[337,498],[333,506],[456,552],[714,638],[822,673],[841,682]],
    4: [[286,230],[434,264],[583,300],[684,321],[715,325],[728,329],[732,329],[713,336],[650,367],[603,398],[507,444],[435,484],[401,499],[325,538],[306,549],[306,550],[333,557],[443,578],[570,596],[657,614],[721,626],[792,645],[821,657]],
    5: [[305,199],[387,237],[526,312],[599,353],[624,360],[633,366],[634,366],[515,441],[401,516],[355,553],[329,570],[339,572],[350,575],[467,598],[693,647],[748,659],[770,666]],
    6: [[319,246],[356,259],[432,277],[565,317],[654,348],[695,360],[700,363],[710,365],[681,376],[630,396],[453,468],[354,510],[335,522],[325,530],[322,534],[358,536],[546,585],[637,610],[732,639],[735,642],[750,646]],
    7: [[341,249],[540,332],[640,366],[675,376],[666,381],[649,389],[608,404],[406,450],[346,479],[340,498],[411,545],[626,635],[698,667],[765,693],[772,695]],
    8: [[318,241],[420,257],[453,271],[484,281],[543,296],[622,324],[661,335],[735,357],[745,358],[759,363],[761,364],[759,364],[741,370],[679,393],[589,431],[489,451],[381,487],[355,496],[343,497],[302,513],[282,524],[311,542],[409,580],[436,590],[520,619],[595,641],[687,662],[754,682],[795,692]]
  },
  "s-curve": {
    0: [[1082,261],[1059,300],[1003,393],[942,468],[898,506],[826,554],[731,531],[695,523],[625,496],[549,454],[416,440],[354,463],[293,508],[185,588],[119,647],[95,679],[90,689]],
    1: [[1086,265],[1073,286],[1055,309],[1037,347],[1018,369],[998,393],[988,409],[965,430],[936,461],[803,564],[781,564],[699,551],[667,530],[609,490],[563,451],[529,424],[393,418],[369,429],[322,446],[299,461],[268,478],[209,528],[148,578],[106,621],[90,645]],
    2: [[1095,254],[1081,298],[1015,413],[949,494],[829,564],[725,556],[683,544],[635,507],[532,420],[462,383],[371,400],[297,435],[252,478],[232,500],[155,572],[98,632],[83,661]]
  },
  "maze": [[59,147],[104,158],[203,181],[241,183],[255,183],[253,190],[247,215],[243,287],[235,325],[229,355],[228,367],[321,402],[471,406],[533,418],[553,425],[553,461],[548,573],[546,586],[545,594],[543,641],[550,641],[571,641],[626,648],[733,654],[761,649],[762,638],[778,577],[793,519],[803,453],[803,424],[803,416],[840,418],[923,442],[995,454],[1018,453],[1020,453],[1015,468],[1005,534],[1001,577],[986,649],[979,705],[968,786]],
  "spiral": {
    0: [[296,319],[418,354],[681,382],[780,390],[812,385],[796,362],[672,345],[474,334],[396,351],[300,410],[349,462],[384,478],[650,506],[732,499],[755,488],[743,471],[635,459],[367,479],[320,500],[315,553],[335,568],[386,594],[443,610],[515,626],[544,632]],
    1: [[286,322],[298,328],[361,348],[454,365],[643,397],[743,381],[758,357],[742,345],[689,336],[660,333],[382,364],[339,391],[328,407],[323,411],[319,440],[406,494],[577,528],[732,531],[829,525],[858,508],[815,476],[699,450],[508,448],[341,488],[296,564],[332,611],[395,637],[465,649]],
    2: [[327,340],[693,380],[799,365],[827,337],[796,326],[689,325],[355,362],[248,420],[243,448],[310,496],[445,519],[626,523],[712,503],[719,483],[721,470],[709,461],[638,452],[359,486],[290,515],[263,542],[309,576],[488,620],[592,640],[617,644],[626,643]]
  }
};

(function () {
  for (var name in matchShapes) {
    var points = matchShapes[name];
    if (Array.isArray(points)) {
      dollarOne.addGesture(name, points);
    } else if (points !== null && typeof points === "object") {
      for (var i in points) {
        dollarOne.addGesture(name, points[i]);
      }
    }
  }
}());


// Cache paper.js methods.
var Point = paper.Point;
var Path = paper.Path;
var Tool = paper.Tool;


/**
 * Sets up canvas to accept sketching.
 * @param  {Element} canvas  Canvas element for paper.js to draw to.
 * @param  {Object} options Options hash.
 * @return {undefined}
 */
var sketch = function (canvas, options) {

  if(!canvas) return;


  var strokeOptions = {
    strokeColor: '#FFF428',
    strokeWidth: 30,
    strokeCap: 'round'
  };
  var pathOptions = Object.assign(strokeOptions, options);


  // Create a new paperscope
  var paperScope = new paper.PaperScope();
  paperScope.setup(canvas);


  // Event handlers.
  var myPath;

  /**
   * Remove old path, instantiate new path, add start point.
   * @param  {Event} event Mouse Event Object
   * @return {undefined}
   */
  var handleMouseDown = function (event) {
    if (myPath) {
      myPath.remove();
    }
    myPath = new Path(pathOptions);
    myPath.add(event.point);
  };

  /**
   * Add new point to sketch
   * @param  {Event} event Mouse Event object.
   * @return {undefined}
   */
  var handleMouseDrag = function (event) {
    myPath.add(event.point);
  };

  /**
   * Simplify path geometry.
   * Dispatch event to canvas with path object as data.
   * Remove path from canvas.
   * @param  {[type]} event [description]
   * @return {[type]}       [description]
   */
  var handleMouseUp = function (event) {
    myPath.simplify();

    var myEvent = new CustomEvent("sketch:finished", { 'detail': myPath });
    canvas.dispatchEvent(myEvent);

    if (myPath) {
      myPath.remove();
    }
  };

  // Instantiates a new paper.js Tool and attaches event handlers.
  var tool = new Tool();
  tool.minDistance = 20;
  tool.onMouseDown = handleMouseDown;
  tool.onMouseDrag = handleMouseDrag;
  tool.onMouseUp = handleMouseUp;

};


/**
 * Draws path to canvas.
 * @param  {Element} canvas  Canvas element for paper.js to draw to.
 * @param  {Path|Array} path    paper.js Path instance, or array of segment coordinates.
 * @param  {Object} options Options hash.
 * @return {undefined}
 */
var drawPath = function (canvas, path, options) {
  if(!canvas || !path) {
    console.warn("A canvas element and points array or paper.js path are required to draw.");
    return;
  }

  // Set stroke style.
  var strokeOptions = {
    strokeColor: '#FFF428',
    strokeWidth: 30,
    strokeCap: 'round'
  };
  var pathOptions = Object.assign(strokeOptions, options);

  // Instantiate new Paper Scope.
  var paperScope = new paper.PaperScope();
  paperScope.setup(canvas);


  // Draw path
  var myPath;
  if (Array.isArray(path)) {
    pathOptions.segments = path;

    myPath = new Path(pathOptions);
    myPath.smooth();
  } else if (path instanceof Path) {
    paperScope.project.activeLayer.addChild(path);
  }

  paperScope.view.draw();
};


/**
 * Parse segment coordinates from paper.js Path instance.
 * @param  {Path} path paper.js Path instance.
 * @return {Array}      Array of segment coordinates.
 *                            [[x1, y1],[x2, y2]]
 */
var parsePoints = function (path) {
  if (path instanceof Path !== true) {
    console.warn("parsePoints requires a paper.js Path object.");
    return [];
  }

  var points = [];

  /**
   * Parse x and y coordinates from a segment and push them to points array.
   * @param  {Segment} segment paper.js Segment instance.
   * @return {undefined}
   */
  function parsePoint(segment) {
    var point = [segment.point.x, segment.point.y];
    points.push(point);
  }

  path.segments.forEach(parsePoint);

  return points;
};


/**
 * Compare path or points array with shape.
 * @param  {Path|Array} points    paper.js Path instance or array of xy coordinates.
 *                                [[x1,y1],[x2,y2]]
 * @param  {String} shapeName Name of desired shape match.
 * @return {Bool}
 */
var match = function (points, shapeName) {
  points = Array.isArray(points) ? points : parsePoints(points);
  var shape = dollarOne.recognize(points);
  return shape === shapeName;
};

module.exports = {
  sketch: sketch,
  match: match,
  drawPath: drawPath,
  parsePoints: parsePoints
};
